/*
 * Single source of truth for company info used across the redesigned site.
 */
import services, {NOT_SURE_OPTION} from "./services";

const site = {
    name: "Strategic Wellness Advocates LLC",
    tagline: "Behavioral Healthcare Services",
    location: "Baltimore, Maryland",
    phones: [
        {label: "443-869-3660", href: "tel:+14438693660"},
        {label: "202-455-2220", href: "tel:+12024552220"},
    ],
    fax: "202-919-3040",
    email: "info@swahealthmd.com",
    officeHours: "Monday–Friday: 9 am–5 pm",
    officeHoursShort: "Monday–Friday, 9 am–5 pm",
    walkInHours: "Tuesdays & Wednesdays: 10 am–3 pm",
    insurance: ["Medicaid", "Medicare", "UnitedHealthcare", "Cigna", "Aetna", "CareFirst"],
    address: {
        lines: ["2901 Druid Park Drive", "Suite 303 A, B & C", "Baltimore, MD 21215"],
        mapsUrl: "https://goo.gl/maps/yHGJdvzuA7qPMono8",
    },
    socials: [
        {label: "Facebook", url: "https://www.facebook.com/people/Strategic-Wellness-Advocates/100087848000142/"},
        {label: "Instagram", url: "https://www.instagram.com/"},
    ],
    programs: [
        {area: "Community Integration", detail: "Integrated SUD/Mental Health (Adult)", accent: "cyan"},
        {area: "Community Integration", detail: "Integrated SUD/Mental Health (Children and Adolescent)", accent: "cyan"},
        {area: "Outpatient Treatment", detail: "Integrated SUD/Mental Health (Adults)", accent: "orange"},
        {area: "Outpatient Treatment", detail: "Integrated SUD/Mental Health (Children and Adolescents)", accent: "orange"},
    ],
    // Options for the "Service of interest" dropdown in the contact form ("I'm not sure" first).
    services: [
        NOT_SURE_OPTION,
        ...services.filter((service) => service.formOption !== NOT_SURE_OPTION).map((service) => service.formOption),
    ],
    legal: {
        // Shown on the Privacy Policy and Terms and Conditions pages. Bump when the text changes.
        effectiveDate: "October 6, 2026",
    },
};

export default site;
